import { z } from 'zod';
import type { WidgetRuntimeConfig } from '../types/public';
import { isLikelyPartnerToken } from './boot-config';

// .passthrough() сохраняет неизвестные ключи в parsed-объекте.
// Backend (cp-core) делает pass-through произвольных полей из
// `channel.params.widget.*` с базовой sanitization — виджет потребляет
// только те, которые умеет (см. напр. core/fab.ts resolveFabPosition).
const schema = z
  .object({
    colors: z
      .object({
        primary: z.string().optional(),
        primaryDark: z.string().optional(),
      })
      .optional(),
    button_text: z.string().optional(),
    title: z.string().optional(),
    telegram_url: z.string().optional(),
    whatsapp_url: z.string().optional(),
    locale: z.enum(['ru', 'ky', 'en']).optional(),
    greeting: z.string().optional(),
    brand: z.string().optional(),
    ws_path: z.string().optional(),
    enabled: z.boolean().optional(),
  })
  .passthrough();

export async function fetchWidgetConfig(
  apiUrl: string,
  token: string,
): Promise<WidgetRuntimeConfig | null> {
  if (!apiUrl || !token) return null;
  if (!isLikelyPartnerToken(token)) return null;
  try {
    const res = await fetch(`${apiUrl}/api/widget/config/${encodeURIComponent(token)}`);
    if (!res.ok) return null;
    const json = await res.json();
    return schema.parse(json) as WidgetRuntimeConfig;
  } catch {
    return null;
  }
}
